import React from 'react'
import ClientTicketModal from './client-ticket-modal.component'
import ModalConfirmation from './../../../../../components/modal/modal-confirmation.component'
import { connect } from 'react-redux'
import { toastActions } from '../../../../../actions'
import { setUserPermissions } from '../../../../../helpers'
import { bindActionCreators } from 'redux'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'

class ClientTicketModalComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isModalOpen: false,
			isQRCodeModalOpen: false
		}
		this.onReturn = onReturn.bind(this)
	}

	componentDidMount() {
		const { user } = this.props
		setUserPermissions(user)
	}

	render() {
		const {
			tickets,
			isAdmin,
			pixData,
			sourceCall,
			isModalOpen,
			isLoadingData,
			promotionCoupon,
			isQRCodeModalOpen
		} = this.props
		const hasTicketsToShow = tickets && tickets.length

		return (
			<React.Fragment>
				<ClientTicketModal
					isAdmin={isAdmin}
					tickets={tickets}
					sourceCall={sourceCall}
					onReturn={this.onReturn}
					pixData={pixData}
					promotionCoupon={promotionCoupon}
					closeModal={this.props.closeModal}
					hasTicketsToShow={hasTicketsToShow}
					isModalOpen={isModalOpen && !isLoadingData}
					isQRCodeModalOpen={isQRCodeModalOpen && !isLoadingData}
				/>
			</React.Fragment>
		)
	}
}

function onReturn(ticketId, cancelAll, isGoing) {
	const returnTicketPromise = this.props.isAdmin
		? this.props.returnTicketAsAdmin(ticketId, cancelAll, isGoing)
		: this.props.returnTicket(ticketId, cancelAll, isGoing)

	returnTicketPromise.then(({ success, errors }) => {
		if (success) {
			this.props.toastSuccess({
				message: 'Cancelamento realizado com sucesso!'
			})
			this.props.handleCancelTicket()
		} else {
			this.props.toastError({
				message: errors.pop() || 'Erro ao realizar cancelamento'
			})
		}
	})
}

// TODO: utilizar selectors
const mapStateToProps = ({ clientTicketModal, client, user }) => ({
	user,
	tickets: clientTicketModal.tickets,
	pixData: clientTicketModal.pixData,
	isLoadingData: clientTicketModal.isLoading,
	isModalOpen: clientTicketModal.isModalOpen,
	promotionCoupon: clientTicketModal.promotionCoupon,
	isQRCodeModalOpen: clientTicketModal.isQRCodeModalOpen,
	isAdmin: client.clientPointsWasLoaded && client.expiringPoints === null
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			closeModal: ClientTicketModalCreators.closeModal,
			returnTicket: ClientTicketModalCreators.returnTicket,
			returnTicketAsAdmin: ClientTicketModalCreators.returnTicketAsAdmin
		},
		dispatch
	)

const ClientTicketModalContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ClientTicketModalComponent)

export default ClientTicketModalContainer
